<cac-dialog-layout title="جزئیات کانفلیکت {{data.name}}" (onSubmit)="onSubmit()">
    <div class="h-4"></div>
  <cac-form-builder [options]="formBuilder"></cac-form-builder>
</cac-dialog-layout>
